import React, { useState } from 'react';
import i18n from "i18next";
import { Dropdown } from 'react-bootstrap';

import t from '../Translation/Translation';
import "/node_modules/flag-icons/css/flag-icons.min.css";

export default function TranslationSelector(props) {
    const [selectedOption, setSelectedOption] = useState(props.current);

    const languages = {
        "en" : t('english'),
        "es" : t('spanish'),
    }

    const langSpans = {
        "en" : <i className="fi fi-gb fis"></i>,
        "es" : <i className="fi fi-es fis"></i>,
    }

    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
        setSelectedOption(lng);
        if(props.func)
            props.func(lng);
    }

    const getLanguage = (lng) => {
        if(lng.indexOf("es-") != -1) {
            return t('spanish');
        } else if(lng.indexOf("es") != -1) {
            return t('spanish');
        } else {
            return t('english');
        }
    }

    const getLanguageSpan = (lng) => {
        if(lng.indexOf("es-") != -1) {
            return <i className="fi fi-es fis"></i>;
        } else if(lng.indexOf("es") != -1) {
            return <i className="fi fi-es fis"></i>;
        } else {
            return <i className="fi fi-gb fis"></i>;
        }
    }

    return (
        <Dropdown className="langSelector">
            <Dropdown.Toggle className="nav-link count-indicator p-0 toggle-arrow-hide bg-transparent">
            <div className="d-inline-flex me-3">
                <div className="fi-holder">
                {getLanguageSpan(selectedOption)}
                </div>
            </div>
            <span className="profile-text font-weight-medium d-none d-md-block">{getLanguage(selectedOption)}</span>
            </Dropdown.Toggle>
            <Dropdown.Menu className="navbar-dropdown preview-list">
            <Dropdown.Item className="dropdown-item  d-flex align-items-center" onClick={e => changeLanguage('en')}>
                <div className="fi-holder">
                <i className="fi fi-gb fis"></i>
                </div>{t('english')}
            </Dropdown.Item>
            <div className="dropdown-divider"></div>
            <Dropdown.Item className="dropdown-item preview-item d-flex align-items-center" onClick={e => changeLanguage('es')}>
                <div className="fi-holder">
                <i className="fi fi-es fis"></i>
                </div>{t('spanish')}
            </Dropdown.Item>
            </Dropdown.Menu>
        </Dropdown>
    );
};